const LINK_ID = "cy-next-fonts";
const HREF =
  "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Rubik:wght@400;500;600;700;800&display=swap";

/**
 * Loads the Inter/Rubik weights used by the new layer. The new layer loads its own
 * weights so old pages keep today's faces (2026-10-14). Idempotent.
 */
export const ensureNextFonts = (): void => {
  if (document.getElementById(LINK_ID)) return;
  const link = document.createElement("link");
  link.id = LINK_ID;
  link.rel = "stylesheet";
  link.href = HREF;
  document.head.appendChild(link);
};
